export enum AlarmReporterIdentityType {
  Unknown = 'Unknown',
  Device = 'Device',
  User = 'User',
}
